<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '合同'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5vh"
    :close-on-click-modal="false"
  >
    <div class="border-style">基本信息</div>
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同编号" prop="ContractNumber">
            <el-input
              v-model.trim="item.ContractNumber"
              placeholder="请输入合同编号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同类型" prop="ContractTypeID">
            <select2
              v-model="item.ContractTypeID"
              url="basic?type=ContractType"
              placeholder="请选择合同类型"
              noDataText="无类型"
              :emptyValue="0"
              :currentList="currentContractType"
              style="width: 100%"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同名称" prop="Name">
            <el-input
              v-model.trim="item.Name"
              placeholder="请输入合同名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属客户" prop="ClientID">
            <select2
              labelName="ClientName"
              v-model="item.ClientID"
              url="client"
              :urlParams="urlParams"
              q="ClientName:like"
              :qinwhere="true"
              :queryOne="false"
              :clearable="false"
              :currentList="currentClient"
              placeholder="请选择客户"
              no-data-text="未找到相关客户"
              :emptyValue="0"
              style="width: 100%"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同签订日期" prop="CheckDay">
            <el-date-picker
              v-model="item.CheckDay"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同开始日期" prop="ContractStartDay">
            <el-date-picker
              v-model="item.ContractStartDay"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="年限" prop="QATime">
            <el-input-number
              v-model="item.QATime"
              :min="1"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务组分类" prop="BusinessGroups">
            <el-select
              v-model="item.BusinessGroups"
              :multiple-limit="6"
              multiple
              filterable
              default-first-option
              placeholder="请选择业务组分类"
              style="width: 100%"
            >
              <el-option
                v-for="code in businessGroupList"
                :key="code.Type"
                :label="code.Name"
                :value="code.Type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同金额" prop="Amount">
            <el-input-number
              v-model="item.Amount"
              :min="0"
              style="width: 100%"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收金额" prop="ActualAmount">
            <el-input-number
              v-model="item.ActualAmount"
              :min="0"
              style="width: 100%"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="签订人" prop="SignName">
            <el-input
              v-model.trim="item.SignName"
              placeholder="请输入签订人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="VirtualStatus">
            <el-select
              v-model="item.VirtualStatus"
              placeholder="请选择状态"
              style="width: 100%"
              disabled
            >
              <el-option label="启动" :value="0"></el-option>
              <el-option label="启动" :value="1"></el-option>
              <el-option label="关闭" :value="2"></el-option>
              <el-option label="撤销" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>

    <div class="border-style">嵌入式销售信息</div>
    <el-form
      :model="item"
      ref="dcisaleform"
      label-width="120px"
      label-position="right"
      :rules="rules"
    >
      <el-row :gutter="25">
        <el-form-item
          :label="`${index + 1}.`"
          v-for="(obj, index) in item.DciSaleInfo"
          :key="index"
          v-if="isShow"
          label-width="40px"
          style="margin-bottom: 0px"
        >
          <el-row>
            <el-col :span="5">
              <el-form-item
                label="产品型号"
                label-width="70px"
                :prop="'DciSaleInfo.' + index + '.DciProductModelName'"
                :rules="rules.CheckDciProductModelName"
              >
                <el-select
                  v-model="obj.DciProductModelName"
                  :clearable="false"
                  placeholder="请选择产品型号"
                  style="width: 100%"
                >
                  <el-option
                    v-for="ele in modelList"
                    :key="ele"
                    :label="ele"
                    :value="ele"
                  >
                  </el-option>
                </el-select>
                <!-- <select2
                  style="width: 100%"
                  labelName="NameNumber"
                  url="dci/model/product/name/list"
                  :clearable="false"
                  placeholder="请选择产品型号"
                  no-data-text="没有产品型号"
                  v-model="obj.DciProductModelName"
                  :ref="'dciselect' + index"
                  :currentList="[]"
                  :urlParams="{
                    where: {},
                  }"
                  q="NameNumber:like"
                  :qinwhere="true"
                  :queryOne="false"
                ></select2> -->
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="销售台数"
                label-width="80px"
                :prop="'DciSaleInfo.' + index + '.DciSaleNum'"
              >
                <el-input-number
                  v-model="obj.DciSaleNum"
                  :min="0"
                  placeholder="请填写销售台数"
                  @input="change($event)"
                  maxlength="10"
                  style="width: 100%"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="现场实施台数"
                label-width="110px"
                :prop="'DciSaleInfo.' + index + '.DciImplementationNum'"
              >
                <el-input-number
                  v-model="obj.DciImplementationNum"
                  :min="0"
                  placeholder="请填写现场实施台数"
                  @input="change($event)"
                  maxlength="10"
                  style="width: 100%"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="远程实施台数"
                label-width="110px"
                :prop="'DciSaleInfo.' + index + '.DciImplementationRemoteNum'"
              >
                <el-input-number
                  v-model="obj.DciImplementationRemoteNum"
                  :min="0"
                  placeholder="请填写远程实施台数"
                  @input="change($event)"
                  maxlength="10"
                  style="width: 100%"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="单价"
                label-width="60px"
                :prop="'DciSaleInfo.' + index + '.UnitPrice'"
              >
                <el-input-number
                  v-model="obj.UnitPrice"
                  :min="0"
                  placeholder="请填写单价"
                  @input="change($event)"
                  maxlength="10"
                  style="width: 100%"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <i
                v-if="index === item.DciSaleInfo.length - 1"
                class="fa fa-plus-circle cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #86c042;
                  margin-left: 10px;
                "
                @click="addDciSaleInfo()"
              ></i>
              <i
                v-if="item.DciSaleInfo.length > 1"
                class="fa fa-minus-circle mar-lft cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #ee4a47;
                  margin-left: 10px;
                "
                @click="delDciSaleInfo(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <div>
          <span style="margin-left: 20px; color: #409eff"
            >实际销售/实施信息：</span
          >
          <div
            style="margin-top: 10px; margin-bottom: 10px"
            v-if="item.DciActSaleInfo && item.DciActSaleInfo.length > 0"
          >
            <p
              style="margin-top: 10px"
              v-for="(obj, index) in item.DciActSaleInfo"
              :key="index"
            >
              <span style="margin-left: 60px"
                >产品型号：<el-tag size="small">{{
                  obj.DciProductModelName
                }}</el-tag></span
              >
              <span style="margin-left: 100px"
                >销售台数:<el-tag size="small">{{
                  obj.DciSaleNum
                }}</el-tag></span
              >
              <span style="margin-left: 100px"
                >现场实施台数:<el-tag size="small">{{
                  obj.DciImplementationNum
                }}</el-tag></span
              >
              <span style="margin-left: 100px"
                >远程实施台数:<el-tag size="small">{{
                  obj.DciImplementationRemoteNum
                }}</el-tag></span
              >
            </p>
          </div>
          <div style="margin-top: 10px; margin-bottom: 10px" v-else>
            <span style="margin-left: 60px">无相关信息</span>
          </div>
        </div>
      </el-row>
    </el-form>

    <div class="border-style">销售产品列表</div>
    <el-table :data="saleList">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        prop="DciProductModel.Name"
        label="产品型号名称"
        width="150"
      />
      <el-table-column
        prop="DciProductModel.Number"
        label="产品型号"
        width="100"
      />
      <el-table-column prop="SN" label="产品SN">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
          <el-tag type="success" v-if="row.Remark">
            {{ row.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="出库日期" align="center" width="100">
        <template slot-scope="{ row }">
          <div v-if="row.StockoutAt">
            {{ row.StockoutAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同">
        <template slot-scope="{ row }">
          <el-tag
            v-for="contractNo in row.ContractNos"
            :key="contractNo"
            style="margin-right: 5px; color: #00b3ca"
            >{{ contractNo }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="border-style">实施产品列表</div>
    <el-table :data="implementationList">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        prop="DciProduct.DciProductModel.Name"
        label="产品型号名称"
        width="150"
      />
      <el-table-column
        prop="DciProduct.DciProductModel.Number"
        label="产品型号"
        width="100"
      />
      <el-table-column prop="SN" label="产品SN">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.DciProduct.SN }}
          </el-tag>
          <el-tag type="success" v-if="row.DciProduct.Remark">
            {{ row.DciProduct.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="合同">
        <template slot-scope="{ row }">
          <el-tag
            v-for="contractNo in row.DciProduct.ContractNos"
            :key="contractNo"
            style="margin-right: 5px; color: #00b3ca"
            >{{ contractNo }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="ImplementationAt" label="实施人员/日期" width="110">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.ImplementationPerson }}
          </el-tag>
          <el-tag type="success" v-if="row.ImplementationAt">
            {{ row.ImplementationAt.substring(0, 10) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ImplementationType" label="实施方式">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ImplementationType === 0" type="success">
            现场实施
          </el-tag>
          <el-tag v-else-if="row.ImplementationType === 1" type="warning">
            远程实施
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ImplementationContent" label="实施内容">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(code, index) in row.ImplementationContent"
            :key="index"
            style="margin-right: 5px; color: #00b3ca"
            >{{ getImplementationContent(code) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="ImplementationDest"
        label="实施目的地"
      />
    </el-table>

    <div class="border-style">嵌入式售后销售信息</div>
    <el-form
      :model="item"
      ref="dciaftersaleform"
      label-width="120px"
      label-position="right"
    >
      <el-row :gutter="25">
        <el-form-item
          :label="`${index + 1}.`"
          v-for="(obj, index) in item.DciAfterSaleInfo"
          :key="index"
          v-if="isAfterShow"
          label-width="40px"
          style="margin-bottom: 0px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="产品SN"
                label-width="70px"
                :prop="'DciAfterSaleInfo.' + index + '.DciProductID'"
              >
                <select2
                  style="width: 100%"
                  labelName="SNRemark"
                  v-model="obj.DciProductID"
                  :url="productUrl"
                  :urlParams="urlproductParams"
                  :clearable="false"
                  placeholder="请选择产品SN"
                  no-data-text="无产品"
                  q="SN|Remark:like"
                  :currentList="curDciProductIDs[index]"
                  :qinwhere="true"
                  :queryOne="false"
                ></select2>
                <!-- <el-select
                  v-model="obj.DciProduct"
                  :clearable="false"
                  placeholder="请选择产品"
                  style="width: 100%"
                >
                  <el-option
                    v-for="ele in productList"
                    :key="ele"
                    :label="ele"
                    :value="ele"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="实施方式："
                label-width="150px"
                :prop="'DciAfterSaleInfo.' + index + '.ImplementationType'"
              >
                <el-radio-group v-model="obj.ImplementationType">
                  <el-radio :label="0">现场实施</el-radio>
                  <el-radio :label="1">远程实施</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <i
                v-if="index === item.DciAfterSaleInfo.length - 1"
                class="fa fa-plus-circle cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #86c042;
                  margin-left: 10px;
                "
                @click="addDciAfterSaleInfo()"
              ></i>
              <i
                v-if="item.DciAfterSaleInfo.length > 1"
                class="fa fa-minus-circle mar-lft cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #ee4a47;
                  margin-left: 10px;
                "
                @click="delDciAfterSaleInfo(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
    </el-form>

    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    businessGroupList: Array,
  },
  data() {
    const validateDciProductModelName = (rule, value, callback) => {
      const arr = rule.fullField.split(".");
      let dciProductModelName = "";
      let check = false;
      if (arr.length === 3) {
        const index = arr[1];
        if (
          this.item.DciSaleInfo[index].DciSaleNum > 0 ||
          this.item.DciSaleInfo[index].DciImplementationNum > 0 ||
          this.item.DciSaleInfo[index].DciImplementationRemoteNum > 0 ||
          this.item.DciSaleInfo[index].UnitPrice > 0
        ) {
          check = true;
        }
        dciProductModelName = this.item.DciSaleInfo[index].DciProductModelName;
      }
      if (check) {
        if (dciProductModelName === "") {
          const msg = "产品型号不能为空";
          callback(new Error(msg));
        } else {
          const sameArr = [];
          let haveSame = false;
          this.item.DciSaleInfo.forEach((item, index) => {
            if (!haveSame) {
              sameArr.forEach((modelName, index) => {
                if (modelName == item.DciProductModelName) {
                  haveSame = true;
                }
              });
            }
            sameArr.push(item.DciProductModelName);
          });
          if (haveSame) {
            callback(new Error("产品型号重复"));
            return;
          }
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "api/contract/upload",
      fileList: [],
      removeList: [],
      attnum: 0,
      atttimes: 0,
      item: {},
      rules: {
        ContractNumber: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        CheckDciProductModelName: [
          { validator: validateDciProductModelName, trigger: "blur" },
        ],
        // Name: [
        //   { required: true, message: "合同名字不能为空", trigger: "blur" },
        // ],
        // CheckDay: [
        //   { required: true, message: "合同签订日期不能为空", trigger: "blur" },
        // ],
        // ContractStartDay: [
        //   { required: true, message: "合同开始日期不能为空", trigger: "blur" },
        // ],
        // ClientID: [
        //   { required: true, message: "客户不能为空", trigger: "blur" },
        // ],
        // ContractTypeID: [
        //   { required: true, message: "合同类型不能为空", trigger: "blur" },
        // ],
        BusinessGroups: [
          { required: true, message: "业务组分类不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      currentClient: [],
      currentContractType: [],

      saleList: [], //嵌入式销售产品列表
      implementationList: [], //嵌入式实施产品列表
      modelList: [], //产品型号
      loading: false,
      maxNum: 0, //记录最大数
      urlParams: { where: {} },
      isShow: true,
      number: 0,
      
      productUrl: "dci/product/stock-list/list?order=-sn",
      urlproductParams: { where: {} },
      isAfterShow: true,
      afterNumber: 0,
      curDciProductIDs: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
  },
  mounted() {
    this.getModelList();
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      if (this.value.ID) {
        if (this.value.ContractType != null) {
          this.currentContractType = [
            {
              ID: this.value.ContractTypeID,
              Name: this.value.ContractType.Name,
            },
          ];
        }
        if (this.value.Client != null) {
          this.currentClient = [
            {
              ID: this.value.ClientID,
              ClientName: this.value.Client.ClientName,
            },
          ];
        }
        if (this.item.Attachments) {
          this.value.Attachments.forEach((ele) => {
            const file = {};
            // file.id = ele.ID;
            file.name = ele.Name;
            file.url = ele.Url;
            this.fileList.push(file);
          });
        } else {
          this.item.Attachments = [];
        }

        this.getSaleList();
        this.getImplementationList();
      }

      if (this.item.DciSaleInfo == null || this.item.DciSaleInfo.length === 0) {
        this.item.DciSaleInfo = [];
        this.item.DciSaleInfo.push({
          DciProductModelName: "",
          DciSaleNum: 0,
          DciImplementationNum: 0,
          DciImplementationRemoteNum: 0,
          UnitPrice: 0,
        });
      }
      
      if (this.item.DciAfterSaleInfo == null || this.item.DciAfterSaleInfo.length === 0) {
        this.item.DciAfterSaleInfo = [];
        this.item.DciAfterSaleInfo.push({
          DciProductID: "",
          ImplementationType: 1,
        });
      }else{
          this.item.DciAfterSaleInfo.forEach((obj, index) => {
            this.curDciProductIDs.push([{
              ID: obj.DciProductID,
              SNRemark: obj.DciProduct.SNRemark,
            }]);
          });
      }
      // 已撤销的合同不能编辑
      if (this.item.VirtualStatus === 3){
        this.submitting = true;
      }
    },
    addDciSaleInfo() {
      this.item.DciSaleInfo.push({
        DciProductModelName: "",
        DciSaleNum: 0,
        DciImplementationNum: 0,
        DciImplementationRemoteNum: 0,
        UnitPrice: 0,
      });
      this.isShow = false;
      this.number += 1;
      this.isShow = true;
    },
    delDciSaleInfo(index) {
      this.item.DciSaleInfo.splice(index, 1);

      this.isShow = false;
      this.number -= 1;
      this.isShow = true;
    },
    addDciAfterSaleInfo() {
      this.item.DciAfterSaleInfo.push({
        DciProductID: "",
        ImplementationType: 1,
      });
      this.isAfterShow = false;
      this.afterNumber += 1;
      this.isAfterShow = true;
    },
    delDciAfterSaleInfo(index) {
      this.item.DciAfterSaleInfo.splice(index, 1);

      this.isAfterShow = false;
      this.afterNumber -= 1;
      this.isAfterShow = true;
    },
    change() {
      this.$forceUpdate();
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    getSaleList() {
      this.$axios
        .post(`contract/dciproducts/sales`, {
          contactNo: this.item.ContractNumber,
        })
        .then((response) => {
          this.saleList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getImplementationList() {
      this.$axios
        .post(`contract/dciproducts/implementations`, {
          contactNo: this.item.ContractNumber,
        })
        .then((response) => {
          this.implementationList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getImplementationContent(code) {
      let name = "";
      if (code === 0) {
        name = '常规联网';
      }
      else if (code === 1) {
        name = '流程调试';
      }
      else if (code === 2) {
        name = '开发调试';
      }
      return name;
    },
    onClose() {
      this.saleList = [];
      this.implementationList = [];
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.dcisaleform.resetFields();
      this.$refs.dciaftersaleform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
      this.curDciProductIDs = [];
    },
    getInputFocus(event) {
      event.currentTarget.select();
    }, //聚焦全选
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$refs.dcisaleform.validate((valid) => {
          if (!valid) {
            return;
          }

          let sum = 0;
          this.item.DciSaleInfo.forEach((obj, index) => {
            sum += obj.DciSaleNum * obj.UnitPrice;
          });
          if (sum > this.item.Amount) {
            this.$message({
              type: "warning",
              message: "销售数量单价总额超过合同金额，请重新确认！",
              duration: 1500,
            });
            return;
          }

          this.submitting = true;

          this.attnum = 0; //有没有新上传附件
          this.$refs.upload.uploadFiles.forEach((item) => {
            if (item.status === "ready") {
              this.attnum += 1;
            }
          });
          if (this.attnum > 0) {
            this.atttimes = 0;
            this.$refs.upload.uploadFiles.map(
              (item) => item.status === "ready"
            );
            this.$refs.upload.submit();
          } else {
            this.lastSubmit();
          }
        });
      });
    },

    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(
            this.item.Attachments.findIndex((item) => item.Url === ele),
            1
          );
        });
        this.$axios.delete("contract/dispose", {
          data: { file: this.removeList },
        });
      }

      if (this.item.DciSaleInfo.length > 0) {
        this.item.DciSaleInfo.forEach((obj, index) => {
          if (obj.DciProductModelName === "") {
            this.item.DciSaleInfo.splice(index, 1);
          }
        });
      }
      if (this.item.DciAfterSaleInfo.length > 0) {
        this.item.DciAfterSaleInfo.forEach((obj, index) => {
          if (obj.DciProductID === "") {
            this.item.DciAfterSaleInfo.splice(index, 1);
          }
        });
      }
      this.$emit("input", this.item);
      const itemData = { ...this.item };
      // 保存的操作
      this.$axios
        .request({
          url: this.item.ID ? `contract/${itemData.ID}` : "contract",
          method: itemData.ID ? "put" : "post",
          data: itemData,
        })
        .then(() => {
          this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
          this.submitting = false;
          this.$emit(itemData.ID ? "form:updated" : "form:created", true);
          this.$emit("form:saved", true);
          this.$emit("update:visible", false);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? "form:updated" : "form:created", false);
          this.$emit("form:saved", false);
        });
    },

    handleSuccess(response) {
      if (this.item.Attachments === null) {
        this.item.Attachments = [];
      }
      this.item.Attachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
  },
};
</script>
<style lang="scss" scoped>
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
